import { Edit } from "@mui/icons-material";
import { FormControl, Tooltip, Button, Typography } from "@mui/material";
import { useState } from "react";

import HNSColors from "../../../../../../ui library/HNSColors";
import { STYLES } from "../../../utils/customStyles";

import SmartyAutoComplete from "./SmartyAutoComplete";

export default function AddressField({
  fieldName,
  fieldValue,
  defaultEditingMode = false,
  onChange,
}) {
  const [isEditing, setIsEditing] = useState(defaultEditingMode);
  const [hovered, setHovered] = useState(false);

  return (
    <FormControl variant="outlined" className="w-full">
      {isEditing ? (
        <div>
          <SmartyAutoComplete
            address={fieldValue}
            setAddress={(val) => {
              onChange(fieldName, val ?? null);
            }}
            hideLabel={true}
            inputSx={{
              ...STYLES.textField,
              "& .MuiOutlinedInput-root:hover fieldset": {
                borderColor: HNSColors.neutrals[400],
              },
              "& .MuiOutlinedInput-root fieldset": {
                borderColor: HNSColors.neutrals[500],
              },
              "& .MuiOutlinedInput-root:hover:not(.Mui-focused) fieldset": {
                borderColor: HNSColors.neutrals[500],
              },
            }}
          />
        </div>
      ) : (
        <Tooltip title="Click to edit">
          <span>
            <Button
              className="flex w-full flex-row justify-between break-all bg-white text-left text-[14px] hover:bg-gray-200"
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
              onClick={() => setIsEditing(true)}
              sx={{
                color: HNSColors.neutrals[100],
                borderRadius: "8px",
                transition: "border-color 0.3s",
                border: `1px solid ${!hovered ? HNSColors.secondary[500] : HNSColors.neutrals[400]}`,
              }}
            >
              <Typography className="align-left" sx={{ ...STYLES.textField }}>
                {fieldValue?.raw && fieldValue.raw.trim() !== "" ? (
                  fieldValue.raw
                ) : (
                  <span className="text-gray-400">Add Address</span>
                )}
              </Typography>
              {hovered && (
                <span>
                  <Edit className="text-gray-400" />
                </span>
              )}
            </Button>
          </span>
        </Tooltip>
      )}
    </FormControl>
  );
}
